import styled from "@emotion/styled"
import { LIGHT_GREY_COLOR } from "theme/colors"

export const Separator = styled.div`
  background: ${LIGHT_GREY_COLOR};
  width: 100%;
  height: 1px;
`
